import React from 'react';

interface Props {
  /** Ein Icon aus `Icon.*`, z. B. `<Icon.Users size={22} />`. */
  icon?: React.ReactNode;
  title: string;
  hint?: string;
  /**
   * Der nächste Schritt: Eine leere Liste ist eine Einladung zu handeln. Ohne
   * Datensätze die Anlegen-Schaltfläche, bei einem Filter ohne Treffer
   * „Filter zurücksetzen“.
   */
  action?: React.ReactNode;
  /** Als Tabellenzeile rendern (colSpan) statt als freier Block. */
  colSpan?: number;
}

const Inhalt: React.FC<Omit<Props, 'colSpan'>> = ({ icon, title, hint, action }) => (
  <div className="empty-state">
    {icon && <div className="empty-state__icon">{icon}</div>}
    <p className="empty-state__title">{title}</p>
    {hint && <p className="empty-state__hint">{hint}</p>}
    {action && <div className="empty-state__action">{action}</div>}
  </div>
);

/** Leerer Zustand einer Liste oder Tabelle. */
const EmptyState: React.FC<Props> = ({ colSpan, ...rest }) =>
  colSpan ? (
    <tr className="empty-state-row">
      <td colSpan={colSpan}><Inhalt {...rest} /></td>
    </tr>
  ) : (
    <Inhalt {...rest} />
  );

export default EmptyState;
